<template>
    <section class="container-card-data-client">
        <ui-tag-indicator color="RGB(28, 202, 133)" :text="data.id" />

        <div class="name-client" @click="openCustomer">
            {{ data.customer.name }}
        </div>

        <div class="personal-data">
            CPF:
            <span v-if="data.customer.cpf">{{ data.customer.cpf | documentBr }}</span>
            <span v-else>Não informado</span>
        </div>

        <div class="cell">
            Celular:
            <span v-if="data.customer.mobile" class="data-cell">{{ data.customer.mobile | phoneMask }}</span>
            <span v-else>Não informado</span>
        </div>

        <div class="email">
            E-mail:
            <span class="data-email">{{ data.customer.email || 'Não informado' }}</span>
        </div>

        <div class="see-more-data" :class="{'block': dataSection == true}" @click="moreData">Ver mais dados</div>

        <div v-if="dataSection" class="data-section">
            <div class="hr" />

            <div v-if="data.owners" class="box-responsible">
                <span class="responsible">Responsáveis</span>

                <span v-if="data.owners.owner" class="team">
                    Responsável: {{ data.owners.owner.first_name }}
                </span>

                <span v-if="data.owners.team" class="team">
                    Equipe: {{ data.owners.team.name }}
                </span>

                <span v-if="data.owners.manager && data.owners.manager.user" class="manager">
                    Gerente: {{ data.owners.manager.user.first_name }}
                </span>

                <span v-if="data.owners.broker && data.owners.broker.user" class="broker">
                    Corretor: {{ data.owners.broker.user.first_name }}
                </span>
            </div>

            <div class="hr" />

            <div class="box-steps-status">
                <span class="steps-status">Etapa e Status</span>

                <span class="steps">Etapa: {{ data.stage ? data.stage.name : 'Não informada' }}</span>

                <span class="status">Status: {{ data.status ? data.status.name : 'Não informado' }} </span>
            </div>

            <div class="hr" />

            <div class="box-registration-updates">
                <span class="registration-updates">Cadastro e Atualizações</span>

                <span class="registration">Cadastro: {{ data.created_at | moment("DD/MM/YYYY [às] H:m:s") }}</span>

                <span class="updates">Atualização: {{ data.updated_at | moment("DD/MM/YYYY [às] H:m:s") }}</span>

                <span class="see-less" @click="closeMore">Ver menos dados</span>
            </div>
        </div>
    </section>
</template>

<script>
	import { uiTagIndicator } from '@/components/ui/tags'

    import { phoneMask, documentBr } from '@/filters'

    export default {
        name: "ui-card-data-client",

        components: {
            uiTagIndicator
        },

        filters: { documentBr, phoneMask },

        props: {
            data: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                dataSection: false
            }
        },

        methods: {
            moreData() {
                this.dataSection = true
            },
            closeMore() {
                this.dataSection = false
            },
            /**
             * Trata o evento de quando solicita-se abrir a interna do cliente
             */
            openCustomer() {
                window.open(`/vendas/negocios/${this.data.id}`, '_blank')
            }
        },
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>